import { render, staticRenderFns } from "./ElectronicHistory.vue?vue&type=template&id=c514ba0c&scoped=true"
import script from "./ElectronicHistory.vue?vue&type=script&lang=js"
export * from "./ElectronicHistory.vue?vue&type=script&lang=js"
import style0 from "./ElectronicHistory.vue?vue&type=style&index=0&id=c514ba0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c514ba0c",
  null
  
)

export default component.exports